import React from 'react';
import PropTypes from 'prop-types';
import {convertPipeToBrTag} from "../../../utils";

/**
 * GlobalNavigationLink
 */
const GlobalNavigationLink = ({
                                pageName,
                                pcText,
                                mbText,
                                href,
                                external,
                                current,
                              }) => {
  //
  const getPcText = () => {
    if (pcText !== null) {
      return pcText;
    }
    return pageName;
  };
  const getMbText = () => {
    if (mbText !== null) {
      return mbText;
    } else {
      if (pcText !== null) {
        return pcText;
      }
    }
    return pageName;
  };
  //
  return (
    <a className={'GlobalNavigation__link' + ((current === true) ? ' current': '')}
       href={(href !== null) ? href: ''}
       target={(external === true) ? '_blank': null}
    >
      <span className="GlobalNavigation__link-container">
        <span className="GlobalNavigation__link-pc">
          <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
        </span>
        <span className="GlobalNavigation__link-mb">
          <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
        </span>
        <span className="GlobalNavigation__link-icon3"/>
      </span>
      <span className="GlobalNavigation__link-border"/>
    </a>
  )
};
GlobalNavigationLink.propTypes = {
  pageName: PropTypes.string,
  pcText: PropTypes.string,
  mbText: PropTypes.string,
  href: PropTypes.string,
  external: PropTypes.bool,
};
GlobalNavigationLink.defaultProps = {
  pageName: null,
  pcText: null,
  mbText: null,
  href: null,
  external: null,
};
export default GlobalNavigationLink;



// WEBPACK FOOTER //
// ./src/containers/global-navigation/link/index.jsx